/** HingeJoint3D registration: the parser. Property knowledge for linting lives in linterParser.ts. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseHingeJoint3D } from './parser';
const hingeJoint3DRegistration = {
    typeName: 'HingeJoint3D',
    parser: parseHingeJoint3D,
};
nodeRegistry.register(hingeJoint3DRegistration);
//# sourceMappingURL=index.js.map